import type {
  CreatePersonalApiKeyMutationVariables,
  PersonalApiKeyMetadataFragment,
} from '@affine/graphql';
import { LiveData, Service } from '@toeverything/infra';

import type { PersonalApiKeyStore } from '../stores/personal-api-key';

export class PersonalApiKeyService extends Service {
  private revalidationId = 0;
  keys$ = new LiveData<PersonalApiKeyMetadataFragment[] | null>(null);
  loading$ = new LiveData(false);
  error$ = new LiveData<unknown>(null);

  constructor(private readonly store: PersonalApiKeyStore) {
    super();
  }

  async revalidate() {
    const id = ++this.revalidationId;
    this.loading$.value = true;
    try {
      const keys = await this.store.list();
      if (id !== this.revalidationId) return;
      this.keys$.value = keys;
      this.error$.value = null;
    } catch (error) {
      if (id === this.revalidationId) this.error$.value = error;
    } finally {
      if (id === this.revalidationId) this.loading$.value = false;
    }
  }

  async create(input: CreatePersonalApiKeyMutationVariables) {
    const revealed = await this.store.create(input);
    await this.revalidate();
    return revealed;
  }

  async rotate(id: string, expirationDays: number | null) {
    const revealed = await this.store.rotate(id, expirationDays);
    await this.revalidate();
    return revealed;
  }

  async revoke(id: string) {
    await this.store.revoke(id);
    await this.revalidate();
  }
}
